'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import UIFlex from 'UIComponents/layout/UIFlex';

const Footer = props => /*#__PURE__*/_jsx(UIFlex, Object.assign({}, props, {
  align: "baseline",
  justify: "between",
  wrap: "wrap"
}));

export default Footer;